// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"d3f175cb","277":"7e9e458d","280":"0a012d25","410":"fc09c8af","417":"f7719229","687":"86c8d9ed","717":"f9a981e8","787":"ac5d05cc","807":"a96a94b1","959":"47c6bcca"}[chunkId] + ".chunk.js";
};